// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1ENwT","colMin":"styles_colMin__2HSAg","colCheckbox":"styles_colCheckbox__1dg5R"};